<template>
  <div class="card-list">
    <div
      v-for="item of list"
      :key="item.goods_sn"
    >
      <router-link
        :to="{ name: 'prodetail', query: { pid: item.goods_sn } }"
        class="card"
      >
        <div class="card-pic">
          <img :src="item.pic">
        </div>
        <div class="right-contain">
          <div class="card-name"> {{ item.goods_name }}</div>
          <div class="price">{{ $setInfoDecimal(item.goods_price) }}</div>
          <!-- <div class="addcar">
          <button @click="addcart(item.goods_sn)"></button>
        </div> -->
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
// import { addcar } from '@/api/car'
export default {
  props: {
    list: Array
  },
  methods: {
    // async addcart (id) {
    //   const result = await addcar({
    //     goods_sn: id,
    //     num: 1
    //   })
    //   this.$toast(result.data.data.message)
    // }
  }
}
</script>
<style lang="scss" scoped>
.card-list {
  padding: 0.2rem 0.1rem;

}

.card {
  display: flex;
  justify-content: space-between;
  margin: 0.1rem 0;
  padding: 0.1rem;
  border: 1px solid #eee;
  height: 1.5rem;
  color: #000;
  border-radius: 5px;


  .card-pic {
    img {
      width: 1.5rem;
      height: 1.5rem;
      border: 1px solid #eee;
      border-radius: 5px;
    }
  }

  .right-contain {
    width: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 0.23rem;

    .card-name {
      // height: fit-content;
      display: -webkit-box;
      /*弹性伸缩盒子*/
      // -webkit-box-orient: vertical;
      /*子元素垂直排列*/
      // white-space: nowrap;
      /*溢出不换行*/
      line-clamp: 2;
      -webkit-line-clamp: 2;
      /*显示的行数*/
      overflow: hidden;
      /*溢出部分隐藏*/
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
    }

    .addcar {
      button {
        width: 0.32rem;
        height: 0.32rem;
        background: url('../../../../assets/icon/addcar.png') no-repeat;
        background-size: 0.32rem;
        border: none;
      }
    }
  }


}
</style>